import React from 'react';
import { LOCATION_REQUIRED_FIELDS, ALL_LOCATION_OPTIONAL_FIELDS,
         CHARGER_REQUIRED_FIELDS, ALL_CHARGER_OPTIONAL_FIELDS,
         CONNECTOR_REQUIRED_FIELDS, ALL_CONNECTOR_OPTIONAL_FIELDS } from '../config/evseFields';

export default function WizardStepReview({
  organisationMode, organisationId, organisationName, organisations,
  locationFormData, chargers, connectors, schedules
}) {
  const orgDisplayName = organisationMode === 'existing'
    ? organisations.find(o => String(o.id) === String(organisationId))?.name
    : organisationName;

  const allLocationFields = [...LOCATION_REQUIRED_FIELDS, ...ALL_LOCATION_OPTIONAL_FIELDS];
  const allChargerFields = [...CHARGER_REQUIRED_FIELDS, ...ALL_CHARGER_OPTIONAL_FIELDS];
  const allConnectorFields = [...CONNECTOR_REQUIRED_FIELDS, ...ALL_CONNECTOR_OPTIONAL_FIELDS];

  return (
    <>
      <div className="review-block">
        <div className="review-block-title">Organisation</div>
        <div className="review-row">
          <span className="review-row-label">Registering for</span>
          <span className="review-row-value">{orgDisplayName || '—'}</span>
        </div>
      </div>

      <div className="review-block">
        <div className="review-block-title">Location</div>
        {allLocationFields.map(field => {
          const value = locationFormData[field.name];
          if (!value) return null;
          return (
            <div className="review-row" key={field.name}>
              <span className="review-row-label">{field.label}</span>
              <span className="review-row-value">{value}</span>
            </div>
          );
        })}
      </div>

      {schedules && schedules.filter(s => s.tariff_id).length > 0 && (
        <div className="review-block">
          <div className="review-block-title">Tariffs</div>
          {schedules.filter(s => s.tariff_id).map((s, i) => (
            <div className="review-row" key={s.tempId}>
              <span className="review-row-label">Tariff {i + 1}</span>
              <span className="review-row-value">
                {s.start_time && s.end_time ? `${s.start_time} – ${s.end_time}` : 'All times'}
              </span>
            </div>
          ))}
        </div>
      )}

      {chargers.map((charger, index) => {
        const chargerConnectors = connectors.filter(c => c.chargerTempId === charger.tempId);

        return (
          <div className="review-block" key={charger.tempId}>
            <div className="review-block-title">Charger {index + 1}</div>
            {allChargerFields.map(field => {
              const value = charger.formData[field.name];
              if (!value) return null;
              return (
                <div className="review-row" key={field.name}>
                  <span className="review-row-label">{field.label}</span>
                  <span className="review-row-value">{value}</span>
                </div>
              );
            })}

            {chargerConnectors.length === 0 ? (
              <div className="review-row">
                <span className="review-row-label" style={{ color: 'var(--red)' }}>
                  No connectors assigned to this charger
                </span>
              </div>
            ) : (
              chargerConnectors.map((connector, cIndex) => (
                <div key={connector.tempId} style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed var(--border)' }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--srlk-green-dark)', marginBottom: 4 }}>
                    Connector {cIndex + 1}
                  </div>
                  {allConnectorFields.map(field => {
                    const value = connector.formData[field.name];
                    if (!value) return null;
                    return (
                      <div className="review-row" key={field.name}>
                        <span className="review-row-label">{field.label}</span>
                        <span className="review-row-value">{value}</span>
                      </div>
                    );
                  })}
                </div>
              ))
            )}
          </div>
        );
      })}
    </>
  );
}